import React from 'react'
import config from '../../config/index'
import homeLightLogo from '../../images/icons/listing-management-logo.svg'

const homeLightLogoSrc = homeLightLogo.default || homeLightLogo

export function Logo() {
  return (
    <a href={config.homePageUrl} className="hlm-logo" aria-label="HomeLight Listing Management">
      <img src={homeLightLogoSrc} alt="HomeLight Listing Management" />
    </a>
  )
}
